<div class="w-100 d-flex flex-column align-items-center justify-content-center">
    <div>
      <img src="../../../../assets/img/logo-enexdirecto.png" class="img-fluid mt-4 mb-5" />
    </div>
  <h2 class="text-center mb-4">Cambiar contraseña</h2>
  </div>
    <div class="recovery-container px-4 px-md-3 h-100 mb-5">

    <form [formGroup]="formChange" (submit)="openDialog()">

      <div class="form-group">
        <div class="custom-input-group mb-3">
          <div class="input-group-prepend">
            <span class="icon-Contrasena"></span>
          </div>
          <input type="password" formControlName="pwActual" id="pwActual" class="form-control" placeholder="Contraseña actual" aria-label="Contraseña actual"
          [class.border-danger]="f.pwActual.errors && (f.pwActual.dirty || f.pwActual.touched)">
          <div class="form-message">
            <small>*Obligatorio</small>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="custom-input-group mb-3">
          <div class="input-group-prepend">
            <span class="icon-Contrasena"></span>
          </div>
          <input type="password" formControlName="pwNueva" id="pwNueva" class="form-control" placeholder="Nueva contraseña" aria-label="Nueva contraseña"
          [class.border-danger]="f.pwNueva.errors && (f.pwNueva.dirty || f.pwNueva.touched)">
          <div class="form-message">
            <small>*Obligatorio</small>
          </div>
        </div>
      </div>
      <div class="form-group mb-4">
        <div class="custom-input-group mb-3">
          <div class="input-group-prepend">
            <span class="icon-Contrasena"></span>
          </div>
          <input type="password"  formControlName="confirmaPw" id="confirmaPw" class="form-control" placeholder="Confirmación nueva contraseña" aria-label="Confirmación nueva contraseña"
          [ngClass]="{
            'border-danger': validaConfirmacion() == false
          }">
          <div class="form-message">
            <small>*Obligatorio</small>
          </div>
        </div>
      </div>



      <div class="col-12 col-md-10 mx-auto d-flex flex-column justify-content-center">
        <button type="submit" class="btn btn-success btn-block mb-4" [disabled]="formChange.invalid || !validaConfirmacion()">
          <span *ngIf="!loader.change;else tmpLoader">Confirmar</span>
        </button>
      </div>
    </form>

    <div class="alert alert-danger alert-dismissible fade show mt-3" *ngIf="error.status" role="alert">
      {{ error.descripcion}}
    </div>

    <div class="row no-gutters d-flex justify-content-center h-100">

      <div style="align-self: flex-end;">
        <img src="../../../../assets/img/logo-enex.svg" class="img-fluid logo-enex mx-auto mb-3" />
      </div>
    </div>
  </div>


  <ng-template #tmpLoader>
    <span class="spinner-border text-white" role="status">
      <span class="sr-only">Loading...</span>
    </span>
  </ng-template>
